import { Form, Button, Spin } from 'antd';
import { useSSOTFilterData, useUserInfo,useSSOTFilterApply} from "./store";
import RenderFilterFields from './RenderFilterFields';
import { useState, useEffect } from 'react';


const SSOTFilter = ({ visible, onClose, queryParam, onApplyFilters,setSsotUserData, setQueryParam , setCurrentPage,setPageSize, setTriggerFetch}) => {
  const { newFiltersData, fetchSSOTFilters, newFiltersLoading } = useSSOTFilterData();
  const { fetchSSOTFiltersApply, newFiltersApplyData } = useSSOTFilterApply();
  const { userDataV1, fetchUserDataV1 } = useUserInfo();
  const [form] = Form.useForm();

  const handleFieldChange = (fieldCode, value) => {
    form.setFieldsValue({ [fieldCode]: value });
  };

  const handleFinish = (values) => {
    onApplyFilters(values);
    onClose();
  };

  const handleClear = () => {
    form.resetFields(); 
    const initialQueryParam = {
      pageSize: 10,
      pageNumber: 1,
      call_provider: [],
      current_status: [],
      desgination: [],
      first_name: undefined,
      house: [],
      location: [],
      process: [],
      reporting_manager: undefined,
      shift: [],
      team: undefined,
      week_off: [],
    };
    setQueryParam(initialQueryParam);
    setTriggerFetch(true) 
    setCurrentPage(1);
    setPageSize(10);
    onClose(); 
  };
  

  return (
    <Spin spinning={newFiltersLoading}>
      <Form layout="vertical" onFinish={handleFinish} form={form} >

        <RenderFilterFields filtersData={newFiltersData} onFieldChange={handleFieldChange} />

        <div className="d-flex justify-content-between">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={handleClear}>
            Clear
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

export default SSOTFilter;